export default __webpack_public_path__ + "static/media/CircledUserIcon.9f7cb1e2.svg";